import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MapListSliderComponent } from '@tools/components/map-list-slider/map-list-slider.component';
import { CommonModule } from '@angular/common';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';

@NgModule({
    declarations: [
        MapListSliderComponent
    ],
    imports: [
        MatButtonModule,
        MatLegacySlideToggleModule,
        MatIconModule,
        MatTooltipModule,
        CommonModule
    ],
    exports: [
        MapListSliderComponent
    ]
})
export class MapListSliderModule
{
}
